import React from 'react';
//import { Props as SidebarProps } from '~components/Sidebar';
import { widthContextData } from '~contextProviders/WidthContextProvider';
import {
  StyledSidebar,
  IconWrapper,
  CloseIcon,
  Content,
} from './styledComponents';

type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export type Props = Omit<SidebarProps, 'side' | 'duration'>;

const RightSidebar = ({ children, onClose, isOpen, ...props }: Props) => {
  const { isXs } = widthContextData.useCtx();

  return (
    <StyledSidebar
      onClose={onClose}
      isOpen={isOpen}
      duration={isXs ? 300 : 400}
      side='right'
      {...props}
    >
      <IconWrapper>
        <CloseIcon onClick={onClose} />
      </IconWrapper>
      <Content>{children}</Content>
    </StyledSidebar>
  );
};

export default RightSidebar;
